export class EventTarget {
    addEventListener(type, listener, // @todo EventListenerOrEventListenerObject | null = null,
    options) {
        // @todo Implement the addEventListener() method.
        listener; // tslint:disable-line:no-unused-expression
        options; // tslint:disable-line:no-unused-expression
        type; // tslint:disable-line:no-unused-expression
    }
    dispatchEvent(evt) {
        // @todo Implement the dispatchEvent() method.
        evt; // tslint:disable-line:no-unused-expression
        return false;
    }
    removeEventListener(type, listener, // @todo EventListenerOrEventListenerObject | null = null,
    options) {
        // @todo Implement the removeEventListener() method.
        listener; // tslint:disable-line:no-unused-expression
        options; // tslint:disable-line:no-unused-expression
        type; // tslint:disable-line:no-unused-expression
    }
}
//# sourceMappingURL=/build/es2018/event-target.js.map